import { Row, Col } from "react-bootstrap";
import NukeRequest from "../../../../components/atoms/nukeRequest";
import SubmitButton from "../../../../sitel/demon/ui/atoms/buttons/SubmitButton";

export default function NavigationButtons({isSubmitting, isSubmitSuccessful}) {
    return (
        <Row className="mt-5">
            <Col>
                <div className="form-group float-end text-center">
                    <NukeRequest>Cancel Request</NukeRequest>
                    <SubmitButton isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful} defaultLabel="Save and Continue to Upload Documents" className="btn-medstar-primary me-2 ms-2"/>
                </div>
            </Col>
        </Row>

    );
}

